import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_51c8754f";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_51c8754f" };
/** script content **/
require("./index.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex51c8754f%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Faction-sheet%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_51c8754f"],
    ctorType: "component",
    outputPath: "components/index51c8754f/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-popup': getComponent(require("../popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex")), 'cube-button': getComponent(require("../button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")), 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
